import { UploadImageField } from "../../../../common/components/form/UploadImageField/UploadImageField";
import VehcileBound from "../forms/fields/VehicleBound";
import { useRenterDashboardContext } from "../renter-dashboard/useRenterDashboardContext";
import { RENTER_STATUS } from "../../../../types/renter.type";
import { Suspense, useEffect, useMemo, useState } from "react";
import { EditBond } from "../modals/fields/EditBondRenterVehcile/EditBond";
import { RenterDocumentsRow } from "../forms/fields/RenterDocumentsRow";
import { UploadDocumentField } from "../forms/fields/UploadDocumentField";
import { updateRenterProps } from "../../../../common/services/renters.api";
import { EditUnlinkBond } from "../modals/fields/EditBondRenterVehcile/EditUnlinkBond";
import { differenceInDays } from "date-fns";
import { RentalHistory } from "./table-rental-vehicle/RentalHistory";
import { getVisualRecords } from "../../../../common/services/vehicles.api";
import { getCompanySigla } from "@/common/helpers/company.helpers";
import { Button } from "@/components/ui/button";
import { ModalViewLogs } from "@/modules/logsDetails/logsDetails.modal";
import { maskPhone } from "@/common/helpers/mask.helpers";

const STATUS_LABELS = {
  [RENTER_STATUS.Ativo]: "Ativo",
  [RENTER_STATUS.Incompleto]: "Incompleto",
  [RENTER_STATUS.PendentePagamento]: "Pendente de pagamento",
  [RENTER_STATUS.ProntoParaAprovacao]: "Pronto para aprovação",
  [RENTER_STATUS.ReservaPendentePagamento]: "Reserva pendente de pagamento",
  [RENTER_STATUS.ReservaPaga]: "Reserva paga",
  [RENTER_STATUS.Finished]: "Finalizado",
  [RENTER_STATUS.Recision]: "Recisão",
  [RENTER_STATUS.Recall]: "Recolhimento",
  [RENTER_STATUS.WaitingRescision]: "Aguardando recisão",
  [RENTER_STATUS.Congelado]: "Congelado",
};

function getStatusLabels(status: RENTER_STATUS) {
  return STATUS_LABELS[status] || status;
}

export function ImageSelfBlock() {
  const { renter } = useRenterDashboardContext();
  const [isLogModalOpen, setIsLogModalOpen] = useState(false);

  const renterId = renter._id;

  const pathToUpload = useMemo(() => `customers/${renterId}`, [renterId]);

  const [showEditModal, setShowEditModal] = useState(false);
  const [showUnlinkModal, setShowUnlinkModal] = useState(false);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [register, setRegister] = useState<any>();
  const [returnReason, setReturnReason] = useState<string>("");

  const handleOpenEditModal = () => {
    setShowEditModal(true);
  };

  const handleCloseEditModal = () => {
    setShowEditModal(false);
  };

  const handleOpenUnlinkModal = () => {
    setShowUnlinkModal(true);
  };

  const handleCloseUnlinkModal = () => {
    setShowUnlinkModal(false);
  };

  const saveRenterAvatarImage = async (avatar) => {
    await updateRenterProps(renterId || "", {
      avatar,
    });
  };

  const renterURI = encodeURI(`https://app.octadesk.com/chat/empty`);

  function statusDisplay(cancelDate) {
    if (renter.status === `recolhimento`) {
      const rescisionDaysLeft =
        10 - differenceInDays(new Date(), new Date(cancelDate));
      return `${getStatusLabels(
        renter.status
      )} (10 dias) - faltam: ${rescisionDaysLeft} dias`;
    } else {
      return getStatusLabels(renter.status);
    }
  }

  const vehicleHistory = renter?.desactivationData?.vehicleHistory;

  let cancelDate;
  let vehiclesId;

  if (vehicleHistory && vehicleHistory.length > 0) {
    cancelDate = vehicleHistory[vehicleHistory.length - 1].vehicleHistoryEnd;
    vehiclesId = vehicleHistory[vehicleHistory.length - 1]?.id;
  }
  const vehicleId = renter?.activationData?.vehicle?.id
    ? renter?.activationData?.vehicle?.id
    : vehiclesId;

  useEffect(() => {
    async function loadRegisterData(vehicleId: string, renterId: string) {
      if (!vehicleId && !renterId) return;

      const searchData = {
        vehicleId: vehicleId,
        renterId: renterId,
      };
      const { data, ok } = await getVisualRecords(searchData);
      if (ok && Array.isArray(data)) {
        type VisualRecord = {
          createdAt: string;
          returnReason?: string;
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          [key: string]: any;
        };
        const dataArray = data as VisualRecord[];
        const sortedDataWithPhotos = dataArray.sort(
          (a, b) =>
            new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
        );
        const latestRecordWithReason = sortedDataWithPhotos.find(
          (r) => r.returnReason
        );

        setReturnReason(latestRecordWithReason?.returnReason || "");
        setRegister(sortedDataWithPhotos);
      }
    }

    if (vehicleId && renterId) {
      loadRegisterData(vehicleId, renterId);
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vehicleId]);

  return (
    <>
      <div className="tabs-border-line">
        <section className="tabs-item-style">
          <div className="max-w-7xl grid grid-rows-3 gap-3 grid-cols-3 rounded-md dark:text-black bg-[#f2f2f2]">
            <div className="row-span-3">
              <UploadDocumentField
                currentSrc={renter.avatar}
                pathToUpload={pathToUpload}
                handleUploadSrc={(src) => saveRenterAvatarImage(src)}
              >
                {({ src, onNewFile, onRemoveClick }) => (
                  <UploadImageField
                    src={src}
                    onNewFile={onNewFile}
                    onRemoveClick={onRemoveClick}
                  />
                )}
              </UploadDocumentField>
            </div>
            <div className="row-span-3 col-span-2 grid grid-rows-3 grid-cols-2 ">
              <h4 className="font-semibold text-2xl col-span-2">
                {" "}
                {renter.name}{" "}
              </h4>
              <span className="p-2 flex items-center bg-white/30 rounded-l-md border border-gray/50 border-r-0">
                {" "}
                Cidade:{" "}
              </span>
              <span className="p-2 flex items-center bg-white/50 rounded-r-md border border-gray/50 border-l-0">
                {getCompanySigla(renter.companyId) || "Não definida"}
              </span>

              <span className="p-2 flex items-center bg-white/30 rounded-l-md border border-gray/50 border-r-0">
                {" "}
                WhatsApp:{" "}
              </span>
              <span className="p-2 flex items-center bg-white/30 rounded-r-md border border-gray/50 border-l-0">
                {" "}
                <a
                  href={renterURI}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="font-medium text-indigo-600 hover:text-indigo-800 underline"
                >
                  {maskPhone(renter.whatsapp)}
                </a>
              </span>

              <span className="p-2 flex items-center bg-white/50 rounded-l-md border border-gray/50 border-r-0">
                {" "}
                Status:{" "}
              </span>
              <span className="p-2 flex items-center bg-white/50 rounded-r-md border border-gray/50 border-l-0">
                {statusDisplay(cancelDate)}
              </span>

              <span className="p-2 flex items-center bg-white/50 rounded-l-md border border-gray/50 border-r-0">
                {" "}
                Situação:{" "}
              </span>
              <span className="p-2 flex items-center bg-white/50 rounded-r-md border border-gray/50 border-l-0">
                {renter.situation || "Não definida"}
              </span>

              <span className="p-2 flex items-center bg-white/50 rounded-l-md border border-gray/50 border-r-0">
                {" "}
                ID na Velotrack:{" "}
              </span>
              <span className="p-2 flex items-center bg-white/50 rounded-r-md border border-gray/50 border-l-0">
                {" "}
                {renter.externalReferences.velotrackDriverId}{" "}
              </span>
            </div>
          </div>
        </section>

        <div className="div-tabs-border-line"></div>

        <section className="tabs-item-style">
          {renter.activationData ? (
            <div className="flex flex-col ">
              <div className="flex flex-col sm:flex-row items-center justify-between">
                <h2 className="text-2xl font-semibold mb-4">
                  Situação do Cliente:
                </h2>
                <div className="flex sm:flex-row sm:space-x-2 mt-2 sm:mt-0 w-full sm:w-auto justify-between">
                  <div className="relative group inline-block">
                    <button
                      className={`bg-redPrimary text-white font-semibold p-2 rounded-md mb-2 sm:mb-0 ${
                        renter.activationData.vehicle.id === ""
                          ? "opacity-50 cursor-not-allowed"
                          : ""
                      }`}
                      type="button"
                      onClick={handleOpenUnlinkModal}
                      disabled={renter.activationData.vehicle.id === ""}
                    >
                      Recolhimento
                    </button>
                    {renter.activationData.vehicle.id === "" && (
                      <span className="absolute left-0 bottom-full mb-2 hidden w-40 px-2 py-1 text-xs text-white bg-black rounded group-hover:block">
                        Não é possível clicar porque o cliente não possui
                        veículo vinculado.
                      </span>
                    )}
                  </div>
                  <div className="relative group inline-block">
                    <button
                      className={`bg-redPrimary text-white font-semibold p-2 rounded-md mb-2 sm:mb-0 ${
                        renter.activationData.plan.planType === ""
                          ? "opacity-50 cursor-not-allowed"
                          : ""
                      }`}
                      type="button"
                      disabled={renter.activationData.plan.planType === ""}
                      onClick={handleOpenEditModal}
                    >
                      Editar
                    </button>
                    {renter.activationData.plan.planType === "" && (
                      <span className="absolute left-0 bottom-full mb-2 hidden w-40 px-2 py-1 text-xs text-white bg-black rounded group-hover:block">
                        Não é possível editar porque o plano não está definido.
                      </span>
                    )}
                  </div>
                </div>
              </div>
              <VehcileBound />
            </div>
          ) : (
            <Suspense />
          )}
          {showEditModal && (
            <EditBond
              data={renter}
              register={register}
              reuturnReason={returnReason}
              vehicleId={vehicleId}
              onClose={handleCloseEditModal}
            />
          )}
          {showUnlinkModal && (
            <EditUnlinkBond
              data={renter}
              onClose={handleCloseUnlinkModal}
              vehicleId={vehicleId}
              register={register}
            />
          )}
        </section>

        {renter._id && (
          <div className="">
            <div className="div-tabs-border-line"></div>
            <section className="tabs-item-style">
              <RenterDocumentsRow
                renterId={renter._id as string}
                currentPath={renter.contratoPdfIleva}
                currentPathRescisao={renter.rescisaoPdf}
              />
            </section>
          </div>
        )}
        <div className="div-tabs-border-line"></div>

        <section className="tabs-item-style">
          <div className="max-w-4xl mx-auto ">
            <h2 className="text-2xl font-semibold mb-4">
              Histórico de locações
            </h2>
            {renter.desactivationData?.vehicleHistory?.length != 0 &&
            renterId ? (
              <RentalHistory
                data={renter}
                renterId={renterId}
                register={register}
              />
            ) : (
              <Suspense />
            )}
          </div>
        </section>
        <div className="div-tabs-border-line"></div>
        <section className="tabs-item-style">
          <div className="max-w-7xl mx-auto ">
            <Button
              variant="destructive"
              className={`bg-redPrimary text-white font-semibold p-2 rounded-md mb-2 sm:mb-0`}
              onClick={() => setIsLogModalOpen(true)}
            >
              Visualizar Logs
            </Button>
          </div>
        </section>
      </div>
      {isLogModalOpen && renterId && (
        <ModalViewLogs
          onClose={() => setIsLogModalOpen(false)}
          entity="renter" // Entidade fixa como solicitado
          entityId={renterId} // ID do veículo do contexto
        />
      )}
    </>
  );
}
